/*
 * PROD-7828 R11 — Email logs: pure form/query logic. Limits are pinned to email_enums.json (server's
 * INVALID_TEXT bounds); a reason is additionally required client-side (Kuldeep 2026-09-29, stricter
 * than the server, which only requires it non-empty — see the build report).
 */
const text = (raw) => String(raw === null || raw === undefined ? '' : raw);

// Code points, as the server counts runes (the penalties module's HL8 convention).
export const char_length = (raw) => Array.from(text(raw).trim()).length;

export const LIMITS = {
  GREETING_MAX_LEN: 256,
  INTRO_MAX_LEN: 2000,
  FOOTER_MAX_LEN: 2000,
  REASON_MAX_LEN: 1024
};

export const blank_text_form = () => ({ greeting: '', intro: '', footer: '', reason: '' });

const required_error = (raw, label, max) => {
  const n = char_length(raw);
  if (n === 0) return `Enter ${label}.`;
  if (n > max) return `${label} must be at most ${max} characters.`;
  return '';
};

export const reason_error = (raw) => {
  const n = char_length(raw);
  if (n === 0) return 'Say why the text is changing.';
  if (n > LIMITS.REASON_MAX_LEN) {
    return `The reason must be at most ${LIMITS.REASON_MAX_LEN} characters.`;
  }
  return '';
};

export const text_form_errors = (form) => ({
  greeting: required_error(form.greeting, 'a greeting', LIMITS.GREETING_MAX_LEN),
  intro: required_error(form.intro, 'an intro', LIMITS.INTRO_MAX_LEN),
  footer: required_error(form.footer, 'a footer', LIMITS.FOOTER_MAX_LEN),
  reason: reason_error(form.reason)
});

export const has_text_errors = (errors) => Object.values(errors).some(Boolean);

// Client-side filter over the already-loaded teacher rows (small dataset; no server round trip).
export const filter_teacher_rows = (rows, q) => {
  const needle = text(q).trim().toLowerCase();
  if (!needle) return rows;
  return rows.filter(
    (r) =>
      String(r.teacher_name || '').toLowerCase().indexOf(needle) !== -1 ||
      String(r.teacher_slug || '').toLowerCase().indexOf(needle) !== -1
  );
};
